<template>
  <div>
    <div class="container-fluid">
      <div class="row mt-3">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <video-player-el
            ref="muzikRef0"
            autoPlayId="0"
            :muzikDetails="pinnedMuzik"
            :isPinned="true"
            :isSearchedMuzik="isSearchedMuzik"
            @onMuzikPlay="onMuzikPlay"
            @onMuzikPause="onMuzikPause"
            @onMuzikEnded="onMuzikEnded"
            @onMuzikDestroy="onMuzikDestroy"
            @onMuzikTagSelect="applyMuzikTagFilter"
          />
        </div>
      </div>

      <div class="row mt-3">

        <div
          class="col float-left"
          v-if="selectedMuzikTags.length<=0"
        >
          <div class="row col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <select
              name="searchType"
              @change="onSearchTypeChange()"
              class="form-control mr-3 mb-3 col-xl-4 col-lg-6 col-md-5 col-sm-12 col-xs-12"
              v-model="searchType"
            >
              <option value="name">Song Name</option>
              <option value="originalArtist">Artist</option>
              <option value="movie">Movie</option>

            </select>

            <vue-bootstrap-typeahead
              class="mb-3 col-xl-4 col-lg-5 col-md-6 col-sm-12 col-xs-12"
              v-model="nameSearchText"
              :data="searchableArray"
              @hit="performNameSearch"
              @input="performNameSearch"
            />
          </div>

        </div>

      </div>

      <div
        class=" mt-3 card bg-primary"
        style="background: -webkit-linear-gradient(50deg, #fd9f85 50%, #e837c2)"
      >
        <div class="col float-left card-header">
          <button
            v-for="muzikTag in muzikTags"
            v-bind:key="muzikTag"
            v-on:click="applyMuzikTagFilter(muzikTag)"
            style="outline: none;"
            class="badge badge-pill mr-2 mb-1 py-1"
            v-bind:class="(selectedMuzikTags && selectedMuzikTags.includes(muzikTag)) ? 'badge-success' : 'badge-dark'"
          ><span class="px-1">{{muzikTag}}
            </span>
            <!-- <i class='fa fa-tag'></i> -->
          </button>
          <button
            v-if="selectedMuzikTags.length>0"
            type="button"
            v-on:click="clearMuzikTags()"
            class="badge badge-danger text-white font-weight-bold btn-sm"
          >Clear Selection<i
              class="ml-1 fa fa-times"
              aria-hidden="true"
            ></i>

          </button>
        </div>

        <div
          v-if="muzikLibrary.length===0"
          class="card-body text-warning text-center font-weight-normal font-italic bg-dark col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"
        >
          No results found for entered text or selected tags
        </div>
      </div>

      <div class="row">
        <div
          class="col-xl-4 col-lg-6 col-md-12 col-sm-12 col-xs-12"
          v-for="(muzikDetails,index) in muzikLibrary.filter(muzik => !muzik.isPinned)"
          v-bind:key="muzikDetails.id"
        >
          <video-player-el
            :ref="'muzikRef' + (index+1)"
            :autoPlayId="(index+1)"
            :muzikDetails="muzikDetails"
            :selectedMuzikTags="selectedMuzikTags"
            @onMuzikPlay="onMuzikPlay"
            @onMuzikPause="onMuzikPause"
            @onMuzikEnded="onMuzikEnded"
            @onMuzikDestroy="onMuzikDestroy"
            @onMuzikTagSelect="applyMuzikTagFilter"
          />
        </div>

      </div>

    </div>
  </div>
</template>

<script>
import VideoPlayerEl from "@/components/VideoPlayer.vue";
import muzikLibraryData from "@/assets/muzikDataLibrary.ts";

import VueBootstrapTypeahead from "vue-bootstrap-typeahead";

export default {
  name: "Home",
  components: {
    VideoPlayerEl,
    VueBootstrapTypeahead,
  },
  data() {
    return {
      currentMuzik: null,
      pinnedMuzik: muzikLibraryData.filter((muzik) => muzik.isPinned)[0],
      isSearchedMuzik: false,
      searchType: "name",
      nameSearchText: "",
      searchableArray: [],
      selectedMuzikTags: [], //["asd", "qwe"],
      muzikLibraryCopy: muzikLibraryData,
      muzikLibrary: muzikLibraryData,
      muzikTags: new Set(),
      metadata: [],
      title: "Muzik Dreamer | Ankur Luthra",
    };
  },
  methods: {
    updateMetaData(muzikMatch) {
      if (!muzikMatch) return;

      let axios = require("axios");

      axios
        .get(
          "https://noembed.com/embed?url=https://www.youtube.com/watch?v=" +
            muzikMatch.url
        )
        .then((response) => {
          this.title = response.data.title + " | Muzik Dreamer";
          this.metadata = [
            {
              vmid: "og:description",
              property: "og:description",
              content: muzikMatch.name + "| Muzik Dreamer - Ankur Luthra",
            },
            {
              vmid: "og:title",
              property: "og:title",
              content: response.data.title + " | Muzik Dreamer", //muzikMatch.name + "| Muzik Dreamer - Ankur Luthra",
            },
            {
              vmid: "og:image",
              property: "og:image",
              content: response.data.thumbnail_url,
            },
            {
              vmid: "og:description",
              property: "og:url",
              content: "https://muzikdreamer.com?mzd=" + muzikMatch.url,
            },
            {
              name: "twitter:card",
              content: "summary_large_image",
            },
            {
              name: "twitter:url",
              content: "https://muzikdreamer.com?mzd=" + muzikMatch.url,
            },
            {
              name: "twitter:title",
              content: response.data.title + " | Muzik Dreamer",
            },
            {
              name: "twitter:description",
              content: muzikMatch.name + "| Muzik Dreamer - Ankur Luthra",
            },
            {
              name: "twitter:image",
              content: response.data.thumbnail_url,
            },
          ];
        })
        .catch((error) => {
          (this.title = muzikMatch.name + " | Muzik Dreamer - Ankur Luthra"),
            (this.metadata = [
              {
                name: "og:description",
                content: muzikMatch.name + "| Muzik Dreamer - Ankur Luthra",
              },
              {
                property: "og:title",
                content: muzikMatch.name + "| Muzik Dreamer - Ankur Luthra",
              },
            ]);
        });
    },
    onSearchTypeChange() {
      this.searchableArray = [
        ...new Set(
          this.muzikLibraryCopy
            .filter((muzik) => !muzik.isPinned)
            .map((muzik) => muzik[this.searchType])
        ),
      ];
    },
    performNameSearch() {
      this.muzikLibrary = this.muzikLibraryCopy.filter((item) =>
        item[this.searchType]
          .toLowerCase()
          .includes(this.nameSearchText.toLowerCase())
      );
    },
    onMuzikPlay(muzikVideo) {
      if (this.currentMuzik) {
        this.currentMuzik.pauseVideo();
      }
      this.currentMuzik = muzikVideo;
    },
    onMuzikPause(muzikVideo) {
      if (this.currentMuzik === muzikVideo) {
        this.currentMuzik = null;
      }
    },
    onMuzikEnded(muzikRefId) {
      let muzikRefElement;
      if (this.muzikLibraryCopy.length - 1 === muzikRefId) {
        muzikRefId = "muzikRef0";
        muzikRefElement = this.$refs[muzikRefId];
      } else {
        muzikRefId = "muzikRef" + parseInt(muzikRefId + 1);
        muzikRefElement = this.$refs[muzikRefId][0];
      }
      muzikRefElement.playVideo();
      muzikRefElement.$el.scrollIntoView({
        block: "end",
        scrollBehavior: "smooth",
      });
    },
    onMuzikDestroy(muzikVideo) {
      if (this.currentMuzik === muzikVideo) {
        this.currentMuzik = null;
      }
    },
    applyMuzikTagFilter(muzikTag) {
      if (this.selectedMuzikTags.includes(muzikTag)) {
        this.selectedMuzikTags = this.selectedMuzikTags.filter(
          (tag) => tag !== muzikTag
        );
      } else {
        this.selectedMuzikTags.push(muzikTag);
      }

      this.muzikLibrary = this.muzikLibraryCopy.filter((item) =>
        this.selectedMuzikTags.every((tag) => item.tags.includes(tag))
      );

      this.muzikLibrary = this.muzikLibrary.sort(
        (item1, item2) => item2.id - item1.id
      );
    },
    clearMuzikTags() {
      this.selectedMuzikTags = [];
      this.muzikLibrary = this.muzikLibraryCopy.sort(
        (item1, item2) => item2.id - item1.id
      );
    },
  },
  mounted() {
    let muzikQuery = this.$route.query.mzd;
    if (muzikQuery) {
      let muzikMatch = this.muzikLibraryCopy.find(
        (muzik) => muzik.urlName === muzikQuery
      );

      if (muzikMatch) {
        this.updateMetaData(muzikMatch);
        this.muzikLibraryCopy.forEach((muzik) => {
          if (muzik.urlName === muzikQuery) {
            this.isSearchedMuzik = true;
            muzik.isPinned = true;
            muzik.facebookLink = null;
          }
          if (muzik.urlName !== muzikQuery && muzik.isPinned) {
            muzik.isPinned = false;
          }
        });
      }
    }

    this.muzikLibraryCopy.forEach((muzik) => {
      if (!muzik.isPinned) {
        muzik.tags.forEach((tag) => this.muzikTags.add(tag));
      }
    });

    if (this.isSearchedMuzik) {
      this.muzikLibrary = this.muzikLibraryCopy;
      this.pinnedMuzik = muzikLibraryData.filter((muzik) => muzik.isPinned)[0];
    }
    this.searchableArray = this.muzikLibraryCopy
      .filter((muzik) => !muzik.isPinned)
      .map((muzik) => muzik[this.searchType]);

    this.muzikLibrary = this.muzikLibrary.sort(
      (item1, item2) => item2.id - item1.id
    );
  },
  metaInfo() {
    return {
      title: this.title,
      meta: this.metadata,
    };
  },
};
</script>

<style>
</style>
